export class ScrollToError {
  static toErrorItem(item, opt) {
    const config = opt || { block: 'center', behavior: 'smooth' }
    item.scrollIntoView(config)
  }
}
